import { useState } from 'react'
import CheckBox from '../../../../common/input/CheckBox'
import Text from '../../../../../core/utils/Text'
import Select from '../../../../common/dropdown/Select'
import { useGetWages } from '../../../../../core/services/react-query/setting/wages'
import { useUpdateAUser } from '../../../../../core/services/react-query/user'
import ActionButton from '../../../../common/buttons/ActionButton'

export default function ChangeUserLevel({ user }) {
	const { mutate: updateStar, isLoading } = useUpdateAUser()
	const [payload, setPayload] = useState({
		isCustomStars: false,
		stars: '',
	})

	const onChangePayload = (v, t) => {
		setPayload((x) => ({ ...x, [t]: v }))
	}

	const { data: wages } = useGetWages()

	const updateUserStar = () => {
		updateStar({
			id: user._id,
			data: payload,
		})
	}

	return (
		<div className={'flex justify-center dark:text-gray-300 py-2'}>
			<div className={'flex w-[320px] flex-col gap-2'}>
				<Text tid={'change-userlevel'} />
				<div className='h-[1px] w-[300px] bg-slate-500/20' />
				<div className='flex flex-col gap-2 mt-3'>
					<Text tid={'select-star'} className='text-sm' />
					<Select
						value={payload.stars}
						options={wages?.stars?.map((s) => s.star) || []}
						onValueChange={(idx) => onChangePayload(wages?.stars[idx].star, 'stars')}
						size='small'
					/>
				</div>
				<div className='flex items-center gap-3 mt-3'>
					<CheckBox
						active={payload.isCustomStars}
						onClick={() => onChangePayload(!payload.isCustomStars, 'isCustomStars')}
					/>
					<Text tid={'isCustomStars'} className='text-sm' />
				</div>

				<div className='mt-8'>
					<ActionButton onClick={updateUserStar} active height='42px' isLoading={isLoading}>
						<Text tid='submit' />
					</ActionButton>
				</div>
			</div>
		</div>
	)
}
